//customization: added skiplink to Chatbot when you are in /urp
import React, { useEffect, useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Skiplink, SkiplinkItem } from 'design-react-kit';
import { useLocation } from 'react-router-dom';
import { isRERPortal } from 'rer-theme/helpers/utils';

const messages = defineMessages({
  mainView: {
    id: 'skiplink-main-content',
    defaultMessage: 'Skip to main content',
  },
  navigation: {
    id: 'skiplink-navigation',
    defaultMessage: 'Skip to navigation',
  },
  footer: {
    id: 'skiplink-footer',
    defaultMessage: 'Skip to footer',
  },
  chatbot: {
    id: 'skiplink-chatbot',
    defaultMessage: 'Vai al chatbot',
  },
});

const SkipLinks = () => {
  const intl = useIntl();
  const location = useLocation();
  const [skiplinkChatbot, setSkiplinkChatbot] = useState(false);

  const removeVisuallyHidden = () => {
    const skiplinks = document.querySelectorAll(
      '.skiplinks a.visually-hidden-focusable',
    );

    skiplinks.forEach((link) => link.classList.remove('visually-hidden'));
  };
  // funzione per rimuovere .visually-hidden dagli skiplinks
  // per correggere bug di design-react-kit che li nasconde
  useEffect(() => {
    removeVisuallyHidden();
  }, []);

  useEffect(() => {
    if (skiplinkChatbot) {
      removeVisuallyHidden();
    }
  }, [skiplinkChatbot]);
  useEffect(() => {
    if (location.pathname.startsWith('/urp') && isRERPortal()) {
      setSkiplinkChatbot(true);
    }
  }, [location.pathname]);

  return (
    <div className="public-ui">
      <Skiplink tag="div">
        <SkiplinkItem href="#view" tag="a">
          {intl.formatMessage(messages.mainView)}
        </SkiplinkItem>
        <SkiplinkItem href="#navigation" tag="a">
          {intl.formatMessage(messages.navigation)}
        </SkiplinkItem>
        <SkiplinkItem href="#footer" tag="a">
          {intl.formatMessage(messages.footer)}
        </SkiplinkItem>
        {skiplinkChatbot && (
          <SkiplinkItem href="#userbot_circle-button" tag="a">
            {intl.formatMessage(messages.chatbot)}
          </SkiplinkItem>
        )}
      </Skiplink>
    </div>
  );
};

export default SkipLinks;
